
<div class="component-cont">


            <input [min]="1"  type="number" [ngModel]="qty" name="quantity" #quantity/>
    <button  class="btn btn-refresh btn-sm ml-1 mr-1" (click)="NewValue(quantity.value)" style="font-size: 11px;
    background-color: #46adbb70;
    /* border: 1px solid #dbdbdb; */
    /* padding-top: 8px; */
    /* padding-left: 10px; */">
        <i  class="fa fa-refresh " (click)="NewValue(quantity.value)" #updatebtn i18n></i> </button>
<!--    {{'update'|translate}}-->



</div>

